// HELD FOR — whose held money a payment out of Flagged is (db/0103 held_for; the Command Centre's go, 27 Oct 2026).
// One field for both pay sheets (screens/custody/MoveSheet.tsx, components/v2/custody/MoveForm.tsx): the one
// depositor is pre-selected and shown; among several, he chooses; nothing is offered while it is not settled
// (lib/custody-screen.ts heldForPick). Once a press is made, the name it was made with is shown, fixed.
import { StateLine, TAP } from './kit';
import { groupDigits } from '../lib/custody-format';
import type { FlaggedHolder } from '../lib/custody-screen';
import { heldForPick } from '../lib/custody-screen';

export function HeldForField({ holders, failed, retry, chosen, onChoose, locked, selectClass = 'select w-full' }: {
  holders: ReadonlyArray<FlaggedHolder> | undefined;
  failed: boolean;
  retry: () => void;
  chosen: string | null;
  onChoose: (slug: string | null) => void;
  /** The press already made: its depositor, fixed. */
  locked: string | null | undefined;
  selectClass?: string;
}) {
  const nameOf = (slug: string) => holders?.find((h) => h.partySlug === slug)?.partyName ?? slug;
  if (locked !== undefined) {
    return <p className="text-body"><span className="text-tg-hint">Held for</span> · {locked ? nameOf(locked) : 'Not named'}</p>;
  }
  if (failed && holders === undefined) {
    return <StateLine tone="bad" action={<button type="button" className={TAP} onClick={retry}>Try again</button>}>Couldn&rsquo;t read Flagged&rsquo;s depositors.</StateLine>;
  }
  const pick = heldForPick(holders, chosen);
  if (pick.state === 'reading') return <p className="text-body text-tg-hint">Reading Flagged&rsquo;s depositors…</p>;
  if (pick.state === 'none') return <StateLine tone="bad" more="A deposit's money is held for its customer once its address is tagged.">No tagged deposit is held in Flagged.</StateLine>;
  if (pick.state === 'one') {
    const h = holders![0]!;
    return <p className="text-body"><span className="text-tg-hint">Held for</span> · {h.partyName ?? h.partySlug} · {groupDigits(h.held)} USDT</p>;
  }
  // Gone: the depositor chosen is no longer held — never swapped for whoever is; he chooses again (or nobody is held).
  const gone = pick.state === 'gone'
    ? <StateLine tone="bad">{holders!.length ? 'That depositor is no longer held in Flagged — choose again.' : 'That depositor is no longer held in Flagged.'}</StateLine>
    : null;
  if (pick.state === 'gone' && holders!.length === 0) return gone;
  return (
    <label className="block">
      {gone && <div className="mb-2">{gone}</div>}
      <span className="mb-1 block text-body font-medium">Held for</span>
      <select className={selectClass} value={pick.heldFor ?? ''} onChange={(e) => onChoose(e.target.value || null)}>
        <option value="">Choose whose money</option>
        {/* The amount first: a long name would cut it off in the closed select (Screens' 390 px render, 27 Oct 2026). */}
        {holders!.map((h) => <option key={h.partySlug} value={h.partySlug}>{groupDigits(h.held)} USDT · {h.partyName ?? h.partySlug}</option>)}
      </select>
    </label>
  );
}
